import { jsxs as r, jsx as s } from "react/jsx-runtime";
import { _ as c } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index58.css';const o = "_spinner_50bgg_1", p = "_spinner-bounce_50bgg_9", n = {
  spinner: o,
  spinnerBounce: p
};
function u(e) {
  const { className: i } = e;
  return /* @__PURE__ */ r("div", { className: c(n.spinner, i), children: [
    /* @__PURE__ */ s("div", { className: n.spinnerBounce }),
    /* @__PURE__ */ s("div", { className: n.spinnerBounce }),
    /* @__PURE__ */ s("div", { className: n.spinnerBounce })
  ] });
}
export {
  u as default
};
